export default "__VITE_ASSET__BotI1pIg__"